import React from "react";
import { Fab } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import ActionBar from "@search/ActionBar";
import locale from "@bonliva-crm/locale";
import { store } from "@store";
import { SortOption } from "@search/SortOptions";

type Props = {
  onNew: () => void;
  total: number;
  sortOptions?: SortOption[];
  onSortOption?: (v: SortOption) => void;
};

export function CustomerSearchActionBar(props: Props) {
  return (
    <ActionBar
      actions={[
        <Fab
          key="new"
          color="primary"
          title={locale.New}
          onClick={props.onNew}
          size="small"
          disabled={!store().user.hasPermission("CanAddCustomer")}
        >
          <Add />
        </Fab>,
        <div style={{ fontSize: "16px" }} key="link">
          {locale.NewCustomerLink}{" "}
          <a
            style={{ color: "#ff857a" }}
            href="https://forms.office.com/Pages/ResponsePage.aspx?id=OGRa6DOLKUq4fpqu_-y7-XTe5f0kE7JJv5CcKBnikPxUMjFCQzFJS1BNVDVCUTA0UlhMVkFKTlY4OS4u"
            target="_blank"
            rel="noreferrer"
          >
            {locale.NewCustomerLinkAction}
          </a>
        </div>
      ]}
      onSortOption={props.onSortOption}
      sortOptions={props.sortOptions}
      total={props.total}
      style={{ padding: "8px 16px" }}
    />
  );
}
